// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/customer_order/order_confirmation/v1/order_confirmation.proto (package stailer_service_specification.customer_order.order_confirmation.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/customer_order/order_confirmation/v1/order_confirmation.proto.
 */
const file_stailer_service_specification_customer_order_order_confirmation_v1_order_confirmation = /*@__PURE__*/
  fileDesc("CltzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9jdXN0b21lcl9vcmRlci9vcmRlcl9jb25maXJtYXRpb24vdjEvb3JkZXJfY29uZmlybWF0aW9uLnByb3RvEkJzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi5jdXN0b21lcl9vcmRlci5vcmRlcl9jb25maXJtYXRpb24udjEiggIKEU9yZGVyQ29uZmlybWF0aW9uEuwBCgxjYXV0aW9uX3RleHQYASABKAlC1QGSghmxAeazqOaWh+eiuuiqjeeUu+mdouOBp+ihqOekuuOBmeOCi+azqOaEj+S6i+mgheOCkuioreWumuOBl+OBvuOBmeOAguODh+ODk+ODg+ODiOOCq+ODvOODieWIqeeUqOaZguOBruazqOaEj+eCueOAgeWTgeWIh+OCjOOBruWPr+iDveaAp+OAgeS4jeWcqOaZguOBruWvvuW/nOOBquOBqeOCkuiomOi8ieOBl+OBvuOBmaqCGRvms6jmlofnorroqo3jga7ms6jmhI/kuovpoIViBnByb3RvMw", [file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.customer_order.order_confirmation.v1.OrderConfirmation.
 * Use `create(OrderConfirmationSchema)` to create a new message.
 */
const OrderConfirmationSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_customer_order_order_confirmation_v1_order_confirmation, 0);


exports.file_stailer_service_specification_customer_order_order_confirmation_v1_order_confirmation = file_stailer_service_specification_customer_order_order_confirmation_v1_order_confirmation;
exports.OrderConfirmationSchema = OrderConfirmationSchema;
